// Class for handling HTML Template request, retrieves the template from the 
// template manager and fires a success event with the requested html once its ready

var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.HtmlTemplateRequest = new Class({
    Implements: [Options, Events],
    class_type: "HtmlTemplateRequest",
    class_name: "HtmlTemplateRequest",
    options: {
        arguments: {},
        html_attributes: {},
        url: "",
        template_name: "",
        other_args: {}
    },
    html_requested: false,
    data: {},
    has_completed: false,
    has_data: false,
    request: null,
    bound_methods: {},
    stored_objs: [],
    initialize: function (op) {
        if (!op) {
            return this;
        }
        this.setOptions(op);
        this.bound_methods.on_template_defined = this.on_template_defined.bind(this);
        this.bound_methods.on_success = this.on_success.bind(this);
        this.template_manager = new OCS.Classes.TemplateManager();
        this.template_manager.addEvent('template_defined', this.bound_methods.on_template_defined);
        this.addEvent('success', this.bound_methods.on_success);
        
        var req_manager = OCS.Functions.get_ajax_manager(OCS.Viewer.Config.ajaxManager);
        this.request = req_manager.request(this.options.template_name, {'method': "get", 'url': this.options.url});
        this.request.addEvent('success', this.process_request_success.bind(this));
    },
    add_on_success_obj: function (obj) {
        this.stored_objs.push(obj);
    },
    process_request_success: function (content) {
        this.template_manager.define_template(this.options.template_name, content.text);
    },
    get_other_args: function () {
        return this.options.other_args;
    },
    set_html_attributes: function (html_attributes) {
        this.options.html_attributes = html_attributes;
    },
    set_other_args: function (args) {
        this.options.other_args = args;
    },
    get_html: function (html_attributes) {
        this.html_requested = true;
        if (html_attributes) {
            this.set_html_attributes(html_attributes);
        }
        if (this.template_manager.get_template(this.options.template_name)) {
            this.process_template();
        } else {
            this.request.send();
        }
    },
    process_template: function () {
        var html = this.template_manager.get_html(this.options.template_name, this.options.html_attributes);
        this.fireEvent('success', [html, this], 1);
    },
    on_success: function (html) {
        var i = 0;
        var obj;
        for (i; i < this.stored_objs.length; i++) {
            obj = this.stored_objs.shift();
            obj.set_html(Elements.from(html));
        }
        this.fireEvent('completed', this);
        
    },
    on_template_defined: function (tm, template_name) {
        if (template_name === this.options.template_name) {
            // Since the template is now defined, do not need to continue with the request for it
            if (this.request.running) {
                this.request.cancel();
            }
            if (this.html_requested) {
                this.process_template();
            }
            // Once we have the requested template, remove the event listener
            this.template_manager.removeEvent('template_defined', this.bound_methods.on_template_defined);
        }
    },
    destroy: function () {
        this.template_manager.removeEvent('template_defined', this.bound_methods.on_template_defined);
        this.fireEvent('request_destroyed', this);
        this.removeEvents();
        this.template_manager = null;
        if (this.request.running) {
            this.request.cancel();
        }
        this.request.removeEvents();
        this.request = null;
    }
}); 